module.exports = __webpack_public_path__ + "media/toolkits/COVIDicon-4-4ff67a98.svg";